import oldBrowserCheck from '@spinnwerk/old-browser-check';

export default function ({
    selector      = '.browser-alert--browsehappy',
    closeSelector = '.js-close-browser-alert-info',
} = {}) {
    jQuery(($) => {
        const $element = $(selector),
            oldBrowser = oldBrowserCheck({
                ie: '11',
                firefox: '40',
                chrome: '40',
                opera: '31',
                safari: '8',
                android: '4.4'
            });

        if (oldBrowser) {
            $element.show();

            // init the close click to fade out the element
            $(closeSelector).click(function (event) {
                event.preventDefault();
                $element.fadeOut();
            });
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/alerts/old-browser.js